var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { createEntityCollection } from '../entity';
var RequestError = /** @class */ (function (_super) {
    __extends(RequestError, _super);
    /**
     * @param message 错误信息
     */
    function RequestError(message, _a) {
        var code = _a.code;
        var _this = _super.call(this, message) || this;
        _this.code = null;
        _this.detail = {};
        _this.code = code;
        _this.msg = message;
        return _this;
    }
    RequestError.create = function (options) {
        if (typeof options === 'string' || typeof options === 'number') {
            options = errorCollection.entities[options];
            if (!options) {
                throw new Error('[RequestError] Invalid error type.');
            }
        }
        var message = options.message, code = options.code;
        return new RequestError(message, { code: code });
    };
    RequestError.CLIENT_ERROR = 'CLIENT_ERROR';
    RequestError.SERVER_ERROR = 'SERVER_ERROR';
    RequestError.NETWORK_ERROR = 'NETWORK_ERROR';
    RequestError.TIMEOUT_ERROR = 'TIMEOUT_ERROR';
    return RequestError;
}(Error));
export { RequestError };
var errorCollection = createEntityCollection([
    { code: RequestError.CLIENT_ERROR, message: '客户端错误' },
    { code: RequestError.SERVER_ERROR, message: '服务器错误' },
    { code: RequestError.NETWORK_ERROR, message: '网络错误' },
    { code: RequestError.TIMEOUT_ERROR, message: '网络超时，请重试' },
], function (x) { return String(x.code); });
